import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (pwd216)
// ============================================================

export interface AnomalyDetail {
  doc_no: string;       // FD125_01 / FD143_01
  line_no: number;      // FD125_02 / FD143_02
  anomaly_code: string; // FD125_11 / FD143_11
  desc: string;         // FD125_12 / FD143_12
  sched_date: string | null; // FD125_13 / FD143_13
  doc_type_code: string;     // FD125_14 / FD143_14
  seq_no: number;            // FD125_15 / FD143_15
}

export interface PendingItem {
  doc_type: string;      // "D202" or "D204"
  doc_no: string;        // FD120_01 or FD140_01
  doc_date: string;      // FD120_11 or FD140_12
  vendor_code: string;   // FD120_12 or FD140_10
  anomaly_desc: string;  // FD120_40 or FD140_60
  details: AnomalyDetail[];
}

export interface PendingResponse {
  data: PendingItem[];
  count: number;
}

export interface ApproveItem {
  doc_no: string;
  doc_type: string;
  anomaly_desc: string;
  approved: boolean;
  details: AnomalyDetail[];
  deleted_line_nos?: number[];
}

export interface ApproveRequest {
  items: ApproveItem[];
}

export interface ApproveResponse {
  approved_count: number;
  skipped_count: number;
  errors?: string[];
}

export interface AnomalyCodeInfo {
  code: string;
  desc: string;
  doc_type: number;
}

// ============================================================
// API methods
// ============================================================

export const pwd216Api = {
  /** GET /api/pwd216/pending?start=xxx&end=yyy */
  async getPending(start: string, end: string): Promise<PendingResponse> {
    const res = await apiClient.get('/api/pwd216/pending', {
      params: { start, end },
    });
    return res.data;
  },

  /** POST /api/pwd216/approve */
  async approve(items: ApproveItem[]): Promise<ApproveResponse> {
    const res = await apiClient.post('/api/pwd216/approve', { items, confirmed: true });
    return res.data;
  },

  /** GET /api/pwd216/lookup/anomaly/:code */
  async lookupAnomalyCode(code: string): Promise<AnomalyCodeInfo> {
    if (!code || !code.trim()) {
      return { code: '', desc: '', doc_type: 0 };
    }
    const res = await apiClient.get(`/api/pwd216/lookup/anomaly/${encodeURIComponent(code.trim())}`);
    return res.data;
  },
};
